import { render, staticRenderFns } from "./moduleContent.vue?vue&type=template&id=2a0924f9&scoped=true"
import script from "./moduleContent.vue?vue&type=script&lang=js"
export * from "./moduleContent.vue?vue&type=script&lang=js"
import style0 from "./moduleContent.vue?vue&type=style&index=0&id=2a0924f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0924f9",
  null
  
)

export default component.exports